// extracted by mini-css-extract-plugin
export default {"container":"nX-z","title":"oX-z","link":"pX-z"};